/* eslint-disable max-len */
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import { convertEpochToDateFormat } from '../../../../CommonMethods/convertEpochToDateFormat'
import AnimatedModel from '../../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../../components/ConfirmationPrompt'
import { useLazyDeviceDetailsQuery } from '../../../../slices/alertSlice'
import { convertToPatientTimeZoneDateFormat } from '../../../../CommonMethods/ConvertDatetoPatientTimezone'

const TableBody = ({
    tableData,
    indexNum,
    handleAcknowlegde
}) => {
    const [detailsModal,setDetailsModal] = useState(false);
    const [deviceTrigger,deviceResult] = useLazyDeviceDetailsQuery()
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const date=convertToPatientTimeZoneDateFormat(tableData?.measurement_date_time,dateformat,tableData?.timezone)


    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <> 
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {date}
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all" style={{lineBreak:'anywhere'}}>
                            {tableData?.reading_type==='spo2'?'SPO2':(tableData?.reading_type)?.split('_')?.map((word)=>word.charAt(0).toUpperCase()+word.slice(1)).join(' ')}
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal break-all' style={{lineBreak:'anywhere'}}>
                            {(tableData?.reading === undefined || tableData?.reading === "") ? "-" : tableData?.reading}
                         
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {(tableData?.alert_type === undefined || tableData?.alert_type === "" ) ? "-" : tableData?.alert_type}
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal break-all' style={{lineBreak:'anywhere'}}>
                            {/* Splitting the reading_details by "/" */}
                            <span className={`${tableData?.reading_details?.includes('/') ? "flex" : ""}`}>
                                {tableData?.reading_details?.split('/').map((detail, index, array) => (
                                    <span key={index}>
                                        <span 
                                            className={`${detail === 'Too Low' ? "bg-[#F9E8E9] text-[#D3454D]" : 
                                                detail === 'Too High' ? 'bg-[#EEB9BC] text-[#C81720]' : 
                                                    detail === 'Nominal' ? 'bg-[#9BD6AD] text-[#1A883C]' : 
                                                        (detail === 'Missed Reading' || detail === 'Data Error') ? 'bg-[#E7EAF4] text-[#000000]' : "" } 
                                                        rounded-[28px] px-2 py-1`}
                                        >
                                            {detail}
                                        </span>
                                        {index < array.length - 1 && <span className="mx-1">/</span>}
                                    </span>
                                ))}
                            </span>
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all' style={{lineBreak:'anywhere'}}>
                            {(tableData?.threshold === undefined || tableData?.threshold === "") ? "-" : tableData?.threshold?.includes('/')?tableData?.threshold?.split('/')[0]+" / "+tableData?.threshold?.split('/')[1]:tableData?.threshold }
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all '
                            // onClick={()=>{
                            //     (tableData?.device_id !== undefined && tableData?.device_id !== "-")&&(setDetailsModal(true),
                            //     deviceTrigger(tableData?.device_id))
                          
                            // }}
                        >   
                          
                            {(tableData?.device_id === undefined || tableData?.device_id === "") ? "-" : tableData?.device_id}
                        </td>
                        <td className={`px-[9px] py-2.5 sticky prevent-click last-td bg-white top-0 right-0`}>
                            <div className="flex items-center justify-start">
                                <span  id={'acknowledge'}
                                    className={(tableData?.is_acknowledged === undefined|| tableData?.is_acknowledged === "") ?  "py-1 px-4 rounded-[6px] disabled border border-[#972E4C] text-sm leading-normal font-semibold text-[#972E4C] cursor-pointer":"py-1 px-4 rounded-[6px] disabled text-sm leading-normal font-semibold text-[#52555D] bg-[#E7EAF4]" }
                                    onClick={(tableData?.is_acknowledged === undefined|| tableData?.is_acknowledged === "")  ? () => handleAcknowlegde(tableData) : undefined}
                                >{(tableData?.is_acknowledged === ""||tableData?.is_acknowledged === undefined) ? "Acknowledge" : "Acknowledged"}</span>
                            </div>
                        </td>
                     
                    </>
                    
                }/>
            {detailsModal &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleClose={() => setDetailsModal(false)}
                        tittle= {'Details:'}
                        detailsLoading={deviceResult?.isLoading}
                        showingInfo={true}
                        deviceDetails={deviceResult?.data}
                    />
                }
            />
            }
        </>
    )
}

export default TableBody